import reacttodo from "../../../assets/images/portfolio/reacttodo.webp";
import wheather from "../../../assets/images/portfolio/wheather.webp";
import facebookclone from "../../../assets/images/portfolio/facebookclone.webp";
import portfolio from "../../../assets/images/portfolio/portfolio.webp";
import notesapp from "../../../assets/images/portfolio/notesapp.webp";
import darkcalculator from "../../../assets/images/portfolio/darkcalculator.webp";
import korfez from "../../../assets/images/portfolio/korfez.webp";
import urunkatalog from "../../../assets/images/portfolio/urunkatalog.webp";
import spendmoneyapp from "../../../assets/images/portfolio/spendmoneyapp.webp";
import patikastore from "../../../assets/images/portfolio/patikastore.webp";
import stoklistesi from "../../../assets/images/portfolio/stoklistesi.webp";
import onlineflightapp from "../../../assets/images/portfolio/onlineflightapp.webp";
import memorycardgame from "../../../assets/images/portfolio/memorycardgame.webp";
import textgeneratorapp from "../../../assets/images/portfolio/textgeneratorapp.webp";
import markdownpreviewerapp from "../../../assets/images/portfolio/markdownpreviewerapp.webp";
import covid19trackerapp from "../../../assets/images/portfolio/covid19trackerapp.webp";
import reduxweatherapp from "../../../assets/images/portfolio/reduxweatherapp.webp";
import typingspeedapp from "../../../assets/images/portfolio/typingspeedapp.webp";
import rickandmortycharacters from "../../../assets/images/portfolio/rickandmortycharacters.webp";
import nextauth from "../../../assets/images/portfolio/nextauth.webp";
import vucutkitlendeksihesaplama from "../../../assets/images/portfolio/vucutkitlendeksihesaplama.webp";
import ecommerceapp from "../../../assets/images/portfolio/ecommerceapp.webp";
import nottutmauygulamasi from "../../../assets/images/portfolio/nottutmauygulamasi.webp";
import portfoliositeapp from "../../../assets/images/portfolio/portfoliositeapp.webp";
import cryptoapp from "../../../assets/images/portfolio/cryptoapp.webp";
import memorygame from "../../../assets/images/portfolio/memorygame.webp";
import booksearchapp from "../../../assets/images/portfolio/booksearchapp.webp";
import rockpapergame from "../../../assets/images/portfolio/rockpapergame.webp";
import formbuilderapp from "../../../assets/images/portfolio/formbuilderapp.webp";
import turkishcheckersgame from "../../../assets/images/portfolio/turkishcheckersgame.webp";

// apk start
import patikastoreapk from "../../../assets/apks/patikastore.apk";
import stoklistesiapk from "../../../assets/apks/stoklistesi.apk";

const react_chakra_projects_data = [{
  img: turkishcheckersgame,
  isMobile: false,
  isResponsive: true,
  title: "Turkish Checkers Game",
  html: false,
  css: true,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: false, 
  react: true,    
  nextjs: false,
  reduxx: true,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/turkish-checkers-game" 
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akturkishcheckersgame.netlify.app/" 
  }
},{
  img: formbuilderapp,
  isMobile: false,
  isResponsive: true,
  title: "Form Builder App",
  html: false,
  css: true,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: true, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/form-builder-app" 
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akformbuilderapp.netlify.app/" 
  }
},{
  img: rockpapergame,
  isMobile: false,
  isResponsive: true,
  title: "Rock Paper Scissors Game",
  html: false,
  css: true,
  bootstrap: false,
  sass: true,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: false, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/rock-paper-scissors-game" 
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akrockpaperscissorsgame.netlify.app/" 
  }
},{
  img: booksearchapp,
  isMobile: false,
  isResponsive: true,
  title: "Book Search App",
  html: false,
  css: true,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: false, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/book-search-app" 
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akbooksearchapp.netlify.app/" 
  }
},{
  img: memorygame,
  isMobile: false,
  isResponsive: true,
  title: "Memory Game",
  html: false,
  css: false,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: false, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/memory-game"
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akmemorygameak.netlify.app/"
  }
},{
  img: cryptoapp,
  isMobile: false,
  isResponsive: true,
  title: "Crypto App",
  html: false,
  css: false,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: false, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: true,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/crypto-app"
  },
  isSeeBtn: {
    isThere: true,
    link: "https://akcryptoapp.netlify.app/"
  }
},{
  img: portfoliositeapp, 
  isMobile: false,
  isResponsive: true,
  title: "Portfolio Site App",
  html: false,
  css: false,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: true, 
  react: true,    
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/portfolio-site-app"
  },
  isSeeBtn: {
    isThere: true,
    link: "https://porfoliositeak.netlify.app/"
  }
},{
  img:nottutmauygulamasi,
  isMobile: false,
  isResponsive: true,
  title: "Not Tutma Uygulaması",
  html: false,
  css: false,
  bootstrap: false,
  sass: false,
  js: true,
  typescript: false,
  jqueryy: false,
  jqueryyui: false,
  tailwindd: true,
  react: true,
  nextjs: false,
  redux: false,
  chakra: false,
  node: false,
  mongo: false,
  graphqll: false,
  isCodeBtn: {
    isThere: true,
    link: "https://github.com/alperenkursun/not-tutma-uygulamasi"
  },
  isSeeBtn: {
    isThere: true,
    link: "https://aknottutmauygulamasi.netlify.app/"
  }
}
, {
    img: ecommerceapp, 
    isMobile: false,
    isResponsive: true,
    title: "E-commerce App",
    html: false,
    css: false, 
    bootstrap: false,
    sass: false,
    js: true,
    typescript: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    nextjs: false,
    reduxx: false, 
    chakra: false,
    node: false,
    mongo: false,
    graphqll: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/e-commerce-app", 
    },
    isSeeBtn: {
      isThere: true,
      link: "https://akecommerceapp.netlify.app/",
    },
  },
   {
    img: vucutkitlendeksihesaplama,
    isMobile: false,
    isResponsive: true,
    title: "BMI Calculator App",
    html: false,
    css: false,
    bootstrap: false,
    sass: false,
    js: true,
    typescript: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    nextjs: false,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    graphqll: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/vucut-kitle-endeksi-hesaplama",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://akvucutkitleendeksihesaplama.netlify.app/",
    },
  },
  {
    img: nextauth,
    isMobile: false,
    isResponsive: false,
    title: "Next Auth App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    typescript: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: true,
    react: false,
    nextjs: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    graphqll: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/next-auth",
    },
    isSeeBtn: {
      isThere: false,
      link: "",
    },
  },
  {
    img: rickandmortycharacters,
    isMobile: false,
    isResponsive: true,
    title: "Rick and Morty Characters",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: true,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    graphqll: true,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/rick-and-morty-characters",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://rickandmortycharactersfilter.netlify.app/",
    },
  },
  {
    img: typingspeedapp,
    isMobile: false,
    isResponsive: false,
    title: "Typing Speed App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/typing-speed-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://typingspeedapp.surge.sh/",
    },
  },
  {
    img: reduxweatherapp,
    isMobile: false,
    isResponsive: false,
    title: "Redux Weather App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/redux-weather-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://reduxweatherapp.surge.sh/",
    },
  },
  {
    img: covid19trackerapp,
    isMobile: false,
    isResponsive: false,
    title: "Covid Tracker App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/covid19-tracker-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://akcovid19trackerapp.surge.sh/",
    },
  },
  {
    img: markdownpreviewerapp,
    isMobile: false,
    isResponsive: false,
    title: "Markdown Previewer App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/markdown-previewer-app?tab=readme-ov-file",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://akmarkdownpreviewer.surge.sh/",
    },
  },
  {
    img: textgeneratorapp,
    isMobile: false,
    isResponsive: false,
    title: "Text Generator App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/text-generator-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://aktextgeneratorapp.surge.sh/",
    },
  },
  {
    img: memorycardgame,
    isMobile: false,
    isResponsive: false,
    title: "Memory Card Game",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/memory-card-game",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://memorycardgame01.surge.sh/",
    },
  },
  {
    img: onlineflightapp,
    isMobile: false,
    isResponsive: true,
    title: "Online Flight App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: true,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/online-flight-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://onlineflightapp.netlify.app/",
    },
  },
  {
    img: stoklistesi,
    isMobile: true,
    isResponsive: false,
    title: "Stok Listesi Mobil",
    html: false,
    css: false,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/stok-listesi-app",
    },
    isSeeBtn: {
      isThere: true,
      link: stoklistesiapk,
    },
  },
  {
    img: patikastore,
    isMobile: true,
    isResponsive: false,
    title: "Patikastore Mobil",
    html: false,
    css: false,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/patikastore",
    },
    isSeeBtn: {
      isThere: true,
      link: patikastoreapk,
    },
  },
  {
    img: spendmoneyapp,
    isResponsive: false,
    title: "Spend Money App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: true,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/spend-money-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://spendmoneyapp.surge.sh/",
    },
  },
  {
    img: urunkatalog,
    isResponsive: false,
    title: "Ürün Katalog Projesi",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: true,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/urun-katalog-projesi",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://urunkatalogprojesialperenkursun.surge.sh/",
    },
  },
  {
    img: korfez,
    isResponsive: true,
    title: "Special Security Website",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: true,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/special-security-website-project",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://korfezozelguvenlik.surge.sh/",
    },
  },
  {
    img: darkcalculator,
    isResponsive: false,
    title: "Calculator App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/calculator-app-react",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://calculatorappreact.surge.sh/",
    },
  },
  {
    img: notesapp,
    isResponsive: false,
    title: "Notes App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: true,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/notes-app-redux",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://notesappredux.surge.sh/",
    },
  },
  {
    img: portfolio,
    isResponsive: true,
    title: "Portfolio Project",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: true,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/portfolio-project",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://alperenkursun.netlify.app/",
    },
  },
  {
    img: facebookclone,
    isResponsive: false,
    title: "Facebook Clone",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: true,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/facebook-clone",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://reactfacebookclone.surge.sh/",
    },
  },
  {
    img: wheather,
    isResponsive: false,
    title: "Wheather App",
    html: true,
    css: true,
    bootstrap: false,
    sass: false,
    js: true,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/react-weather-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "https://reactwheatherapp.surge.sh/",
    },
  },
  {
    img: reacttodo,
    isResponsive: false,
    title: "Todo Appp",
    html: false,
    css: false,
    bootstrap: false,
    sass: false,
    js: false,
    jqueryy: false,
    jqueryyui: false,
    tailwindd: false,
    react: true,
    reduxx: false,
    chakra: false,
    node: false,
    mongo: false,
    isCodeBtn: {
      isThere: true,
      link: "https://github.com/alperenkursun/react-todo-app",
    },
    isSeeBtn: {
      isThere: true,
      link: "http://reacttodo1app.surge.sh/",
    },
  },
];

export default react_chakra_projects_data;
